import { observer } from 'mobx-react';
import { FC, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Prompt, Redirect, useParams } from 'react-router-dom';
import { MarketplaceFeaturesParams } from '../../constants/marketplace';
import marketplaceStore from '../../store/marketplaceStore';
import { MarketplaceFeatureKey } from '../../types/marketplace';
import AvailableFeatureContent from './AvailableFeatureContent';
import UnavailableFeatureContent from './UnavailableFeatureContant';
import { SCREENS } from '~/constants/screens';
import { localeStore } from '~/mobx/localesStore';
import { LoadingStatus } from '~/types/main';
import Headers from '~/view/containers/Headers/Headers';
import HeaderBack from '~/view/containers/Headers/components/HeaderBack/HeaderBack';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';

const ContentLoader = () => {
  return <Skeleton width={500} height={100} style={{ borderRadius: 16, marginTop: 25 }} />;
};

const MarketplaceFeatureEdit: FC = observer((): JSX.Element => {
  const { featureKey } = useParams<{ featureKey: MarketplaceFeatureKey }>();

  if (MarketplaceFeaturesParams[featureKey] === undefined) {
    return <Redirect to={SCREENS.MARKETPLACE()} />;
  }

  useEffect(() => {
    marketplaceStore.fetchMarketplaceFeature(featureKey);
    return () => marketplaceStore.setSelectedFeature(null);
  }, []);

  const { name } = MarketplaceFeaturesParams[featureKey];

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title={localeStore.t(name)} path={SCREENS.MARKETPLACE()} />
      </Headers>
      {marketplaceStore.loadingStatus === LoadingStatus.Loading ? (
        <ContentLoader />
      ) : marketplaceStore.selectedFeature?.isPurchased ? (
        <AvailableFeatureContent />
      ) : (
        <UnavailableFeatureContent name={name} />
      )}

      <Prompt when={marketplaceStore.isAnyUnsavedData} message={getPromptProps()} />
    </div>
  );
});

export default MarketplaceFeatureEdit;
